<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">优惠券管理</p>
		</sub-ibox-title>
		<z-tabbar :list-obj="tabbarList"></z-tabbar>
		<section>
			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'Coupon',
		data() {
			return {
				tabbarList: [{
					title: '优惠券列表',
					routeName: 'couponList'
				}
//				,{
//					title: '数据分析',
//					routeName: 'couponStatistics'
//				}
				]
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Main.vue?e2386f68